import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAPI } from 'data/api';
import { MutationPayload } from 'src/hooks/query';

import { Toast } from 'components/Toast';

export const ToastSuccess = () => {
  Toast.toast.success('Installation deleted', {
    position: 'top-right',
    toastId: 'installation-deleted',
    autoClose: 2000,
  });
};

export const useDeleteInstallationMutation = () => {
  const getAPI = useAPI();
  const queryClient = useQueryClient();
  const { projectId } = useParams();

  return useMutation({
    mutationKey: ['deleteInstallation'],
    mutationFn: async (payload: MutationPayload<{installationId: string, integrationId: string}>) => {
      const api = await getAPI();
      if (!projectId) throw Error('Project ID is required');
      
      return api.installationApi.deleteInstallation({
        projectIdOrName: projectId,
        integrationId: payload.data.integrationId,
        installationId: payload.data.installationId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['listInstallations'] });
      queryClient.invalidateQueries({ queryKey: ['listAllInstallations'] });
    },
  });
};
